import { Download, Share2, SquarePlus, X } from 'lucide-react'
import { useState } from 'react'

import { usePwaInstall } from '../../hooks/usePwaInstall'

// Botón reutilizable "Instalar aplicación": se usa tanto en el menú
// (sidebar desktop / menú mobile, que es el mismo <aside>) como dentro
// del banner de instalación. En Android/Chrome dispara el prompt nativo;
// en iOS Safari (que no tiene beforeinstallprompt) abre instrucciones
// paso a paso. La instalación PWA de Franco Frutt es solo para
// móvil/tablet: en PC/Mac/Linux este botón directamente no renderiza
// nada, aunque el navegador haya disparado beforeinstallprompt.
function PwaInstallButton({ className, iconSize = 20, children }) {
  const {
    instalado,
    esIOS,
    isMobileDevice,
    deferredPrompt,
    puedeInstalar,
    instalar,
  } = usePwaInstall()

  const [modalIOSAbierto, setModalIOSAbierto] = useState(false)

  if (!isMobileDevice) return null
  if (instalado) return null
  if (!puedeInstalar) return null

  const alHacerClic = async () => {
    if (deferredPrompt) {
      await instalar()
      return
    }

    if (esIOS) {
      setModalIOSAbierto(true)
    }
  }

  return (
    <>
      <button
        type="button"
        onClick={alHacerClic}
        className={className}
      >
        <Download size={iconSize} />
        {children || 'Instalar aplicación'}
      </button>

      {modalIOSAbierto && (
        <ModalInstruccionesIOS
          onCerrar={() => setModalIOSAbierto(false)}
        />
      )}
    </>
  )
}

function ModalInstruccionesIOS({ onCerrar }) {
  const alHacerClicFuera = (event) => {
    if (event.target === event.currentTarget) {
      onCerrar()
    }
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 p-4"
      onMouseDown={alHacerClicFuera}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="instrucciones-ios-titulo"
        className="w-full max-w-sm rounded-2xl bg-white p-6 shadow-xl sm:p-8"
      >
        <div className="flex items-start justify-between gap-4">
          <h2
            id="instrucciones-ios-titulo"
            className="text-lg font-bold text-slate-900"
          >
            Instalar Franco Frutt
          </h2>

          <button
            type="button"
            onClick={onCerrar}
            aria-label="Cerrar"
            className="shrink-0 text-slate-400 transition hover:text-slate-600"
          >
            <X size={22} />
          </button>
        </div>

        <p className="mt-2 text-sm text-slate-500">
          Safari no permite instalar automáticamente. Sigue estos
          pasos:
        </p>

        <ol className="mt-5 space-y-4">
          <li className="flex items-center gap-4">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-emerald-100 text-emerald-600">
              <Share2 size={20} />
            </span>
            <span className="text-sm text-slate-700">
              Presiona{' '}
              <strong className="font-semibold">Compartir</strong>{' '}
              en la barra de Safari.
            </span>
          </li>

          <li className="flex items-center gap-4">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-emerald-100 text-emerald-600">
              <SquarePlus size={20} />
            </span>
            <span className="text-sm text-slate-700">
              Selecciona{' '}
              <strong className="font-semibold">
                Añadir a pantalla de inicio
              </strong>
              .
            </span>
          </li>

          <li className="flex items-center gap-4">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-emerald-100 text-emerald-600 text-sm font-bold">
              3
            </span>
            <span className="text-sm text-slate-700">
              Presiona{' '}
              <strong className="font-semibold">Añadir</strong>.
            </span>
          </li>
        </ol>

        <button
          type="button"
          onClick={onCerrar}
          className="mt-6 flex w-full items-center justify-center gap-2 rounded-lg bg-emerald-600 px-5 py-3 font-semibold text-white transition hover:bg-emerald-700"
        >
          Entendido
        </button>
      </div>
    </div>
  )
}

export default PwaInstallButton
